import constant from '../../constant'

const initialState = {
  activityInfo: {
    begin_time: '',
    end_time: ''
  },
  commodityTabMap: {},
  tabs: []
};

export function activity (state = initialState, action) {
  if (action.type === constant.E_COMMERCE_FISSION.ACTIVITY_DATA) {
    return {
      ...state,
      ...action
    }
  } else {
    return state
  }
}

const commodityState = {

};
export function commodity(state = commodityState, action) {
  if (action.type === constant.E_COMMERCE_FISSION.COMMODITY_DETAIL) {
    return {
      ...state,
      ...action
    }
  } else {
    return state
  }
}

const dialogState = {
  show: false,
  text: '',
  showHelpDialog: false
};
export function eCommerceDialog(state = dialogState, action) {
  if (action.type === constant.E_COMMERCE_FISSION.DIALOG) {
    return {
      ...state,
      ...action
    }
  } else {
    return state
  }
}